import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};
const modalInputStyle = {
  ...inputStyle,
  borderColor: teal,
};

const TABLE_COLUMNS = [
  "Scheme",
  "Category",
  "Transactions wef.",
  "Brokerage paid wef.",
  "City Category",
  "Trail1%",
  "Trail2%",
  "Trail3%",
  "Trail4%",
  "Actions",
];

export default function EarningRates() {
  const [selectFund, setSelectFund] = useState("");
  const [selectCategory, setSelectCategory] = useState("");
  const [sortBy, setSortBy] = useState("Scheme");
  const [sortDir, setSortDir] = useState("asc");
  const [showCreateRateModal, setShowCreateRateModal] = useState(false);

  // Create Rate modal form state
  const [fundOptional, setFundOptional] = useState("");
  const [categoryOptional, setCategoryOptional] = useState("");
  const [scheme, setScheme] = useState("");
  const [brokerageWef, setBrokerageWef] = useState("");
  const [transactionsWef, setTransactionsWef] = useState("");
  const [cityCategory, setCityCategory] = useState(""); // "T 30" | "B 30"
  const [trail1, setTrail1] = useState("");
  const [trail2, setTrail2] = useState("");
  const [trail3, setTrail3] = useState("");
  const [trail4, setTrail4] = useState("");

  const rows = []; // No data - empty state

  const openCreateRateModal = () => setShowCreateRateModal(true);
  const closeCreateRateModal = () => setShowCreateRateModal(false);

  const resetCreateRateForm = () => {
    setFundOptional("");
    setCategoryOptional("");
    setScheme("");
    setBrokerageWef("");
    setTransactionsWef("");
    setCityCategory("");
    setTrail1("");
    setTrail2("");
    setTrail3("");
    setTrail4("");
  };

  const handleSubmitCreateRate = (e) => {
    e.preventDefault();
    console.log({
      fundOptional,
      categoryOptional,
      scheme,
      brokerageWef,
      transactionsWef,
      cityCategory,
      trail1,
      trail2,
      trail3,
      trail4,
    });
    resetCreateRateForm();
    closeCreateRateModal();
  };

  const handleCloseCreateRate = () => {
    resetCreateRateForm();
    closeCreateRateModal();
  };

  useEffect(() => {
    if (!showCreateRateModal) return;
    const onEscape = (e) => {
      if (e.key === "Escape") handleCloseCreateRate();
    };
    document.addEventListener("keydown", onEscape);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onEscape);
      document.body.style.overflow = "";
    };
  }, [showCreateRateModal]);

  const toggleSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("asc");
    }
  };

  const SortIcon = ({ columnKey }) => (
    <button
      type="button"
      className="btn btn-link p-0 ms-1 border-0"
      style={{ color: sortBy === columnKey ? teal : "#64748b", fontSize: "11px" }}
      onClick={() => toggleSort(columnKey)}
      aria-label={`Sort by ${columnKey}`}
    >
      <i className={`fa fa-sort-${sortBy === columnKey ? (sortDir === "asc" ? "up" : "down") : "up"}`} style={{ opacity: sortBy === columnKey ? 1 : 0.4 }} />
    </button>
  );

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Earning Rates</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/brokerage/income-detail">Brokerage</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Earning Rates
                </li>
              </ol>
            </nav>
          </div>

          {/* Filter and action bar */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-end gap-3">
              <div style={{ minWidth: 180 }}>
                <label className="form-label small fw-semibold text-secondary mb-1 d-block">Select Fund</label>
                <div className="d-flex align-items-center">
                  <span
                    className="d-flex align-items-center justify-content-center rounded-start"
                    style={{
                      padding: "8px 10px",
                      border: "1px solid #e2e8f0",
                      borderRight: "none",
                      backgroundColor: "#fff",
                      color: "#64748b",
                    }}
                  >
                    <i className="fa-solid fa-bars" style={{ fontSize: "12px" }} />
                  </span>
                  <select
                    value={selectFund}
                    onChange={(e) => setSelectFund(e.target.value)}
                    style={{
                      ...inputStyle,
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      flex: 1,
                    }}
                  >
                    <option value="">Select</option>
                  </select>
                </div>
              </div>
              <div style={{ minWidth: 180 }}>
                <label className="form-label small fw-semibold text-secondary mb-1 d-block">Select Category</label>
                <div className="d-flex align-items-center">
                  <span
                    className="d-flex align-items-center justify-content-center rounded-start"
                    style={{
                      padding: "8px 10px",
                      border: "1px solid #e2e8f0",
                      borderRight: "none",
                      backgroundColor: "#fff",
                      color: "#64748b",
                    }}
                  >
                    <i className="fa-solid fa-bars" style={{ fontSize: "12px" }} />
                  </span>
                  <select
                    value={selectCategory}
                    onChange={(e) => setSelectCategory(e.target.value)}
                    style={{
                      ...inputStyle,
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      flex: 1,
                    }}
                  >
                    <option value="">Select</option>
                  </select>
                </div>
              </div>
              <div className="d-flex align-items-center gap-2 ms-auto">
                <button
                  type="button"
                  className="d-flex align-items-center gap-2 border rounded"
                  style={{
                    padding: "8px 16px",
                    background: "#f8fafc",
                    borderColor: "#e2e8f0",
                    color: "#64748b",
                    fontWeight: 600,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa-solid fa-upload" />
                  Bulk Upload
                </button>
                <button
                  type="button"
                  onClick={openCreateRateModal}
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "8px 20px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  Add Rate
                </button>
              </div>
            </div>
          </div>

          {/* Table */}
          <div style={{ ...cardStyle, padding: 0, overflowX: "auto" }}>
            <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f8fafc" }}>
                  {TABLE_COLUMNS.map((label) => (
                    <th
                      key={label}
                      className="text-nowrap"
                      style={{
                        padding: "10px 12px",
                        fontWeight: 600,
                        color: "#334155",
                        borderBottom: sortBy === label ? `2px solid ${teal}` : undefined,
                        backgroundColor: sortBy === label ? "rgba(6, 209, 198, 0.08)" : undefined,
                      }}
                    >
                      {label}
                      {label !== "Actions" && <SortIcon columnKey={label} />}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={TABLE_COLUMNS.length} style={{ padding: "48px 24px", verticalAlign: "middle" }}>
                      <div className="text-center">
                        <div className="mb-2">
                          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: "42px", color: "#f59e0b" }} aria-hidden />
                        </div>
                        <div style={{ fontWeight: 600, color: "#334155" }}>No data available.</div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  rows.map((row, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "10px 12px" }}>{row.scheme}</td>
                      <td style={{ padding: "10px 12px" }}>{row.category}</td>
                      <td style={{ padding: "10px 12px" }}>{row.transactionsWef}</td>
                      <td style={{ padding: "10px 12px" }}>{row.brokeragePaidWef}</td>
                      <td style={{ padding: "10px 12px" }}>{row.cityCategory}</td>
                      <td style={{ padding: "10px 12px" }}>{row.trail1}</td>
                      <td style={{ padding: "10px 12px" }}>{row.trail2}</td>
                      <td style={{ padding: "10px 12px" }}>{row.trail3}</td>
                      <td style={{ padding: "10px 12px" }}>{row.trail4}</td>
                      <td style={{ padding: "10px 12px" }}>
                        <button type="button" className="btn btn-link p-0 text-secondary" aria-label="Actions">
                          <i className="fa fa-ellipsis-v" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Create Rate modal */}
          {showCreateRateModal && (
            <div
              role="dialog"
              aria-modal="true"
              aria-labelledby="create-rate-modal-title"
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                padding: "24px",
              }}
              onClick={(e) => e.target === e.currentTarget && handleCloseCreateRate()}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
                  maxWidth: 520,
                  width: "100%",
                  maxHeight: "90vh",
                  overflow: "auto",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Modal header */}
                <div
                  style={{
                    background: teal,
                    color: "#fff",
                    padding: "14px 20px",
                    borderRadius: "8px 8px 0 0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h2 id="create-rate-modal-title" className="mb-0" style={{ fontSize: "18px", fontWeight: 700 }}>
                    Create Rate
                  </h2>
                  <button
                    type="button"
                    onClick={handleCloseCreateRate}
                    className="border-0 bg-transparent text-white"
                    style={{ fontSize: "20px", cursor: "pointer", padding: "0 4px", lineHeight: 1 }}
                    aria-label="Close"
                  >
                    ×
                  </button>
                </div>

                {/* Modal body - form */}
                <form onSubmit={handleSubmitCreateRate} style={{ padding: "20px" }}>
                  <div className="mb-3">
                    <label className="form-label small fw-semibold text-secondary mb-1">Select Fund (Optional):</label>
                    <select value={fundOptional} onChange={(e) => setFundOptional(e.target.value)} style={modalInputStyle}>
                      <option value="">Select</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label small fw-semibold text-secondary mb-1">Select Category (Optional):</label>
                    <select value={categoryOptional} onChange={(e) => setCategoryOptional(e.target.value)} style={modalInputStyle}>
                      <option value="">Select</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label small fw-semibold text-secondary mb-1">Select Scheme:</label>
                    <select value={scheme} onChange={(e) => setScheme(e.target.value)} style={modalInputStyle}>
                      <option value="">Select</option>
                    </select>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Brokerage w.e.f.:</label>
                      <input type="text" placeholder="DD-MM-YYYY" value={brokerageWef} onChange={(e) => setBrokerageWef(e.target.value)} style={modalInputStyle} maxLength={10} />
                    </div>
                    <div className="col-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Transactions w.e.f.:</label>
                      <input type="text" placeholder="DD-MM-YYYY" value={transactionsWef} onChange={(e) => setTransactionsWef(e.target.value)} style={modalInputStyle} maxLength={10} />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label small fw-semibold text-secondary mb-2 d-block">City Category</label>
                    <div className="d-flex gap-4">
                      <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                        <input type="radio" name="cityCategory" checked={cityCategory === "T 30"} onChange={() => setCityCategory("T 30")} style={{ accentColor: teal }} />
                        T 30
                      </label>
                      <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                        <input type="radio" name="cityCategory" checked={cityCategory === "B 30"} onChange={() => setCityCategory("B 30")} style={{ accentColor: teal }} />
                        B 30
                      </label>
                    </div>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Trail 1 (%) :</label>
                      <input type="text" value={trail1} onChange={(e) => setTrail1(e.target.value)} style={modalInputStyle} />
                    </div>
                    <div className="col-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Trail 2 (%) :</label>
                      <input type="text" value={trail2} onChange={(e) => setTrail2(e.target.value)} style={modalInputStyle} />
                    </div>
                    <div className="col-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Trail 3 (%) :</label>
                      <input type="text" value={trail3} onChange={(e) => setTrail3(e.target.value)} style={modalInputStyle} />
                    </div>
                    <div className="col-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Trail 4 (%) :</label>
                      <input type="text" value={trail4} onChange={(e) => setTrail4(e.target.value)} style={modalInputStyle} />
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      style={{
                        background: teal,
                        color: "#fff",
                        border: "none",
                        padding: "10px 32px",
                        borderRadius: "8px",
                        fontWeight: 600,
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
